var render = function render(){
  var _vm$recruitment;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('dashboard-layout', {
    attrs: {
      "fullHeight": ""
    }
  }, [_c('template', {
    slot: "title"
  }, [_c('v-row', {
    attrs: {
      "no-gutters": "",
      "align": "center"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('h3', {
    staticClass: "tit grey-c--text"
  }, [_vm._v("채용관리")])]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('span', {
    staticClass: "tit__line"
  })]), _c('v-col', {
    attrs: {
      "cols": "auto"
    }
  }, [_c('h3', {
    staticClass: "tit"
  }, [_vm._v(_vm._s((_vm$recruitment = _vm.recruitment) === null || _vm$recruitment === void 0 ? void 0 : _vm$recruitment.subject))])])], 1)], 1), _c('template', {
    slot: "contents"
  }, [_c('v-row', {
    staticClass: "mb-n4 mb-md-12",
    staticStyle: {
      "flex": "0 0 auto"
    },
    attrs: {
      "align-md": "center"
    }
  }, [_c('v-col', {
    staticClass: "mb-10 mb-md-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-row', {
    attrs: {
      "justify": "space-between"
    }
  }, [_c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('v-badge', {
    staticClass: "v-badge--btn",
    attrs: {
      "floating": "",
      "dot": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "text": ""
    },
    on: {
      "click": function ($event) {
        return _vm.$router.go(-1);
      }
    }
  }, [_c('i', {
    staticClass: "icon icon-left-arrow mr-4 mr-lg-8"
  }), _c('h4', {
    staticClass: "tit--sm line-height-1"
  }, [_vm._v("모집현황(목록)")])])], 1)], 1), _c('v-col', {
    attrs: {
      "cols": "12",
      "md": "auto"
    }
  }, [_c('application-list-filter', _vm._b({}, 'application-list-filter', {
    loading: _vm.loading
  }, false))], 1)], 1)], 1), _c('v-col', {
    staticClass: "mb-12 mb-lg-0",
    attrs: {
      "cols": "12"
    }
  }, [_c('v-data-table', _vm._b({
    attrs: {
      "disable-filtering": "",
      "disable-pagination": "",
      "disable-sort": "",
      "hide-default-footer": ""
    },
    on: {
      "click:row": _vm.onClickRow
    },
    scopedSlots: _vm._u([_vm._l(_vm.headers.filter(function (header) {
      return header.hasOwnProperty('formatter');
    }), function (header) {
      return {
        key: `item.${header.value}`,
        fn: function (_ref) {
          var value = _ref.value;
          return [_vm._v(" " + _vm._s(header.formatter(value)) + " ")];
        }
      };
    }), {
      key: `item.resume.personalInformation`,
      fn: function (_ref2) {
        var item = _ref2.item;
        return [_c('application-list-item-personal-information', _vm._b({
          ref: item._id,
          attrs: {
            "value": item
          }
        }, 'application-list-item-personal-information', {
          recruitment: _vm.recruitment
        }, false))];
      }
    }, {
      key: `item.stage`,
      fn: function (_ref3) {
        var item = _ref3.item;
        return [_c('application-list-item-stage', _vm._g({
          attrs: {
            "value": item
          }
        }, {
          updateItem: _vm.updateItem
        }))];
      }
    }, {
      key: "footer",
      fn: function () {
        return [_c('v-divider'), _c('v-row', [_c('v-col', {
          attrs: {
            "cols": "12"
          }
        }, [_c('v-pagination', {
          attrs: {
            "value": _vm.page,
            "length": _vm.pageCount,
            "total-visible": 11,
            "color": "primary"
          },
          on: {
            "input": function (page) {
              return _vm.$router.push({
                query: Object.assign({}, _vm.$route.query, {
                  page
                })
              });
            }
          }
        })], 1)], 1)];
      },
      proxy: true
    }], null, true)
  }, 'v-data-table', {
    headers: _vm.headers,
    items: _vm.items,
    itemClass: _vm.itemClass
  }, false))], 1)], 1)], 1)], 2);

}
var staticRenderFns = []

export { render, staticRenderFns }